/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ComponentCard.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * {
    id,
    cardDataArray={
    key,
    value,
    keyStyle,
    valueStyle,
    data={component object}
}
}
 */

import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import React from "react";
import {
  vlcCardStyles,
  vlcComponentStyle,
} from "../../../components/customComponentsV2/vlc/config/vlcConfig";
import VlcCardContent from "../../../components/customComponentsV2/vlc/cards/VlcCardContent";
import { componentStyle } from "../../../config/appTheme";
import CustomPaginationV2 from "../../../components/customComponentsV2/common/pagination/CustomPaginationV2";
import CustomToolTip from "../../../components/infoButton/CustomToolTip";

function ComponentCard({
  headerTitle,
  dataList,
  handleSelectedComponent = (item) => {},
  selectedComponentDetails,
  renderCardActionIcons,
  page,
  rowsPerPage,
  handlePageChange,
  totalCount,
  idKey = "id",
  contentHeight = null,
  cardStyleProp = (item) => ({}),
  width,
}) {
  return (
    <Box>
      <Card sx={vlcComponentStyle.card}>
        <CardHeader sx={vlcComponentStyle.cardHeader} title={headerTitle} />
        <CardContent
          sx={{
            ...vlcCardStyles.CardContent,
            height: contentHeight || "18rem",
            overflowY: "auto",
            p: 0,
            scrollbarColor: "#888 #f1f1f1",
            scrollbarWidth: "thin",
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#555",
            },
          }}
        >
          {dataList && dataList?.length > 0 ? (
            dataList.map((item, index) => {
              console.log("Rendering ComponentCard item:", item);
              console.log(
                "With selectedComponentDetails:",
                selectedComponentDetails,
              );
              console.log(
                selectedComponentDetails?.[idKey] === item?.id,
                "selectedComponentDetails",
              );

              return (
                <VlcCardContent
                  onClick={(selectedData) => {
                    handleSelectedComponent(selectedData);
                  }}
                  data={item}
                  key={item?.[idKey]}
                  isSelected={selectedComponentDetails?.[idKey] === item?.id}
                  cardStyle={cardStyleProp(item)}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "start",
                      position: "relative",
                      backgroundColor:
                        selectedComponentDetails?.[idKey] === item?.id
                          ? "#f0f0f0"
                          : "#fff",
                      cursor: "pointer",
                    }}
                  >
                    <Box
                      sx={{
                        width: width || "75%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",

                          p: 1,
                        }}
                      >
                        {item?.cardDataArray.map((cardData, cardDataIndex) => (
                          <Typography
                            key={cardData?.key}
                            sx={{
                              ...componentStyle.font.text,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: "100%",
                              display: "flex",
                              gap: 0.5,
                              ...cardData.style,
                            }}
                          >
                            <Box
                              sx={{
                                ...cardData.keyStyle,
                              }}
                            >{`${cardData.key}:`}</Box>{" "}
                            <Box
                              sx={{
                                ...cardData.valueStyle,
                              }}
                            >
                              <CustomToolTip
                                length={25}
                                style={{ ...cardData.valueStyle }}
                              >
                                {cardData.value}
                              </CustomToolTip>
                            </Box>
                          </Typography>
                        ))}
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        width: "25%",
                      }}
                    >
                      {renderCardActionIcons(item.data)}
                    </Box>
                  </Box>
                </VlcCardContent>
              );
            })
          ) : (
            <Typography
              variant="body1"
              sx={{
                textAlign: "center",
                mt: { xs: 1, sm: 2 },
                fontSize: { xs: "0.9rem", sm: "1rem" },
              }}
            >
              No data available
            </Typography>
          )}
        </CardContent>
        <CustomPaginationV2
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          totalItems={totalCount}
        />
      </Card>
    </Box>
  );
}

export default ComponentCard;
